<mat-form-field
    [floatLabel]="floatLabel()"
    class="w-full"
    [color]="color"
    [arcErrorTooltip]="_formControl"
    [subscriptSizing]="hasFixedSubscript ? 'fixed' : 'dynamic'">
    @if (!!label) {
        <mat-label>{{ isLabelTranslated ? label : (label | transloco) }}</mat-label>
    }
    <input
        matInput
        (blur)="onBlur()"
        (change)="onInputChanged()"
        [placeholder]="!placeholder || isPlaceholderTranslated ? placeholder : (placeholder | transloco)"
        [formControl]="internalControl"
        [attr.min]="min()"
        [attr.max]="max()"
        [readonly]="isReadonly()"
        (focus)="focusChanged.emit($event)"
        (keydown.enter)="enterKeyDown.emit()"
        [attr.inputmode]="decimalPlaces() === 0 ? 'numeric' : 'decimal'" />
    @if (unitText() || unit()) {
        <arc-quantity-unit-display
            matTextSuffix
            [unit]="unit()"
            [unitText]="unitText()"
            [unitTooltip]="unitTooltip()"
            [isUnitTranslated]="isUnitTranslated()"
            [unitQuantity]="unitQuantity()"
            [maxSuffixWidth]="maxSuffixWidth()" />
    }
</mat-form-field>
